(function(angular) {
    angular.module('wtUi.wtFilters')
        .filter('capitalize', function() {
            return function(token) {
                return !token ? '' : token.charAt(0).toUpperCase() + token.slice(1);
            };
        });
})(window.angular);
